(ns common.schema.entities.kyc.kyc-profile.core
  (:require [common.features.plan :as plan]
            [common.roles :as roles]
            [common.schema.entities.kyc.kyc-profile.schema :as schema]))

(def entity-type-definition
  {:entity-type                  :entity.type/kyc-profile
   :schema                       schema/schema
   :name                         {:en "KYC profile"}
   :plural                       {:en "KYC profiles"}
   :icon                         :fa-edit
   :entity/mcp-blacklisted?      true

   ;; FE+BE can build name from these without custom code
   :display-name-fn              (fn [{:keys [entity]}]
                                   (:kyc-profile/name entity))
   :display-name/depends-on      [:kyc-profile/name]

   :search                       {:result/title-attr     :kyc-profile/name
                                  :result/subtitle-attrs [:kyc-profile/status]
                                  :list/default-columns  [:kyc-profile/name
                                                          :kyc-profile/status
                                                          :common/updated-on]
                                  :list/default-sort     [:common/updated-on :desc]
                                  :quick-filters         [:kyc-profile/status]
                                  :views                 {:grid
                                                          {:po-default-field-paths [[:kyc-profile/name]
                                                                                    [:kyc-profile/status]
                                                                                    [:kyc-profile/screening-status]
                                                                                    [:kyc-profile/risk-category]
                                                                                    [:kyc-profile/next-deadline]
                                                                                    [:kyc-profile/latest-process-status]
                                                                                    [:kyc-profile/their-kyc-contact]
                                                                                    [:kyc-profile/our-kyc-contact]]
                                                           :mandatory-field-paths [[:kyc-profile/name]]}}}

   :reporting                    {:export/default-fields
                                  [:kyc-profile/name
                                   :kyc-profile/status
                                   :common/created-on
                                   :common/updated-on]
                                  :export/filename-template "kyc_profiles_{{date}}.csv"}
   :permissions                  {:creatable?   true
                                  :disableable? true}

   :read-permissions-check-fn    (fn [{:keys [account-current-permissions tenant role tenant-plan]}]
                                   (and (plan/available :feature/kyc tenant role tenant-plan)
                                        (some #{:module/kyc} (:account-modules account-current-permissions))))
   :disable-permissions-check-fn (fn [{:keys [tr role entity has-write-permissions?]}]
                                   (when-not (or (roles/admin? role)
                                                 ;; TODO: we need explicit delete permissions to be configured for non activity entity types
                                                 (has-write-permissions? entity))
                                     (tr :not-allowed)))})
